"use client";

import React, { useEffect, useRef, useState } from "react";

//Types
import { FilterDateProps } from "@/types";

//Styles
import * as S from "./styles";
import { Calendar } from "lucide-react";
import { format } from "date-fns";
import Input from "../input";
import FormGroup from "../formGroup";
import Button from "@/components/button";

const FilterDate: React.FC<FilterDateProps> = ({
  value,
  onChange,
  onSubmitFilter,
  isOpen = false,
  setIsOpen,
}) => {
  // Estado interno se setIsOpen não for fornecido
  const [internalIsOpen, setInternalIsOpen] = useState(false);
  const actualIsOpen = setIsOpen ? isOpen : internalIsOpen;
  const actualSetIsOpen = setIsOpen || setInternalIsOpen;
  const containerRef = useRef<HTMLDivElement | null>(null);

  const toLocalDate = (value: string) => {
    if (!value || value.trim() === "") {
      return new Date();
    }
    const [year, month, day] = value.split("-").map(Number);
    if (isNaN(year) || isNaN(month) || isNaN(day)) {
      return new Date();
    }
    const date = new Date(year, month - 1, day);
    if (isNaN(date.getTime())) {
      return new Date();
    }
    return date;
  };

  // Estado de abertura agora vem do pai

  const startDate =
    value.start && value.start instanceof Date && !isNaN(value.start.getTime())
      ? value.start
      : new Date();
  const endDate =
    value.end && value.end instanceof Date && !isNaN(value.end.getTime())
      ? value.end
      : new Date();

  const formattedRange = `${format(startDate, "dd/MM/yyyy")} - ${format(endDate, "dd/MM/yyyy")}`;

  useEffect(() => {
    if (!actualIsOpen) {
      return;
    }

    const handleOutsideClick = (event: MouseEvent | TouchEvent) => {
      if (!containerRef.current) {
        return;
      }

      if (!containerRef.current.contains(event.target as Node)) {
        actualSetIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("touchstart", handleOutsideClick);
    };
  }, [actualIsOpen, actualSetIsOpen]);

  return (
    <S.BoxFilterDate ref={containerRef}>
      <S.ButtonFilter onClick={() => actualSetIsOpen(!actualIsOpen)}>
        <Calendar />
        <S.VisibilityInfo>{formattedRange}</S.VisibilityInfo>
      </S.ButtonFilter>
      <S.BoxContentFilter $isOpen={actualIsOpen}>
        <FormGroup>
          <Input
            type="date"
            label="Data Incial"
            name="initialDate"
            value={
              value.start &&
              value.start instanceof Date &&
              !isNaN(value.start.getTime())
                ? format(value.start, "yyyy-MM-dd")
                : format(new Date(), "yyyy-MM-dd")
            }
            onChange={(e) => {
              const newDate = toLocalDate(e.target.value);
              onChange({
                ...value,
                start: newDate,
              });
            }}
          />
        </FormGroup>
        <FormGroup>
          <Input
            type="date"
            label="Data Final"
            name="finshDate"
            value={
              value.end &&
              value.end instanceof Date &&
              !isNaN(value.end.getTime())
                ? format(value.end, "yyyy-MM-dd")
                : format(new Date(), "yyyy-MM-dd")
            }
            onChange={(e) => {
              const newDate = toLocalDate(e.target.value);
              onChange({
                ...value,
                end: newDate,
              });
            }}
          />
        </FormGroup>
        <Button
          widthFull
          text="Aplicar"
          onClick={() => {
            onSubmitFilter && onSubmitFilter();
            // Fecha o popover após aplicar
            actualSetIsOpen(false);
          }}
          variant="success"
        />
      </S.BoxContentFilter>
    </S.BoxFilterDate>
  );
};

export default FilterDate;
